// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { Analytics, formatContainers } from '@trello/atlassian-analytics';
import { ComponentWrapper } from '@trello/component-wrapper';
import { dangerouslyConvertPrivacyString } from '@trello/privacy';

import { setBoardLocation } from 'app/scripts/controller/setBoardLocation';
import type { Member } from 'app/scripts/models/Member';
import type { BoardView } from 'app/scripts/views/board/BoardView';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import { MemberBoardProfileView } from 'app/scripts/views/member/MemberBoardProfileView';
import { isBoardControllerRefactorEnabled } from 'app/src/components/Board/isBoardControllerRefactorEnabled';
import { boardPageState } from 'app/src/components/Board/useBoardPageState';
import {
  dialogProps,
  LazyBoardInviteModal,
} from 'app/src/components/BoardInviteModal';
import { setDocumentTitle } from 'app/src/components/DocumentTitle';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const openAddMembers = function (this: any, e: any) {
  if (e) {
    stopPropagationAndPreventDefault(e);
  }

  const idOrganization = this.model.getOrganization()?.id;
  Analytics.sendClickedButtonEvent({
    buttonName: 'shareButton',
    source: 'boardScreen',
    containers: formatContainers({
      idBoard: this.model.id,
      idOrganization,
      workspaceId: idOrganization,
    }),
  });

  Dialog.show({
    reactElement: (
      <ComponentWrapper>
        <LazyBoardInviteModal
          idBoard={this.model.id}
          idOrg={idOrganization}
          onClose={Dialog.hide}
        />
      </ComponentWrapper>
    ),
    ...dialogProps,
  });
};

export const showMemberProfile = function (this: BoardView, member: Member) {
  setDocumentTitle(dangerouslyConvertPrivacyString(member.get('fullName')));
  if (!Dialog.isVisible) {
    Dialog.show({
      view: new MemberBoardProfileView({
        model: member,
        board: this.model,
      }),
      maxWidth: 500,
      hide: () =>
        isBoardControllerRefactorEnabled()
          ? boardPageState.value.returnToBoard()
          : setBoardLocation(this.model.id),
    });
  }
};
